/**
 * Validate the progress of the review
 *
 * @param {object} messageReviewDetails
 */
export const validateMessageReview = messageReviewDetails => {
  if (messageReviewDetails.pristine) {
    return {
      isCancelDisabled: false,
      isFinishDisabled: true
    };
  }
  const hasReviewed = Object.keys(messageReviewDetails.dialogues).length === 0 ? true : false;
  return {
    isCancelDisabled: false,
    isFinishDisabled: hasReviewed
  };
};
export const validateEscalationReview = (messageReviewDetails, reviewState, reviewRequiredVotingExperts) => {
  const isDisagree = reviewState !== "agree";
  if (messageReviewDetails.pristine) {
    return {
      isCancelDisabled: false,
      isFinishDisabled: true
    };
  }
  const hasReviewed = Object.keys(messageReviewDetails.dialogues).length === 0 ? true : false;
  if (isDisagree) {
    const needsEndorsements = reviewRequiredVotingExperts !== 0;
    return {
      isCancelDisabled: false,
      isFinishDisabled: needsEndorsements && hasReviewed || !needsEndorsements ? true : false
    };
  }
  return {
    isCancelDisabled: false,
    isFinishDisabled: isDisagree
  };
};